import Button, * as Btn from '@lib/components/Button';
import ErrorMessage from '@lib/components/ErrorMessage';
import InputText, * as IInputText from '@lib/components/InputText';
import TitleBar, * as ITitleBar from '@lib/components/TitleBar';
import { RegisterProps } from '@lib/containers/Register';
import { IMAGE_PATH, isEmailValid, PASSWORD_SIZE } from '@lib/util/util';
import * as React from 'react';
import './Register.css';




interface IRegisterState {
  login: string;
  isLoginError: boolean;
  password: string;
  confirmation: string;
  isPasswordError: boolean;
  isConfirmationError: boolean;
  remember: boolean;
}

class Login extends React.Component<RegisterProps, IRegisterState> {

  public constructor(props: RegisterProps) {
    super(props);
    this.state = {
      confirmation: this.props.confirmation, isConfirmationError: false, isLoginError: false, isPasswordError: false, login: this.props.login, password: this.props.password,
      remember: false
    };
  }


  /**
   * Fired when user clicks on "SinUp" button
   * @param state 
   * @param event 
   */
  public onSignupClick(state: IRegisterState, event: React.MouseEvent<HTMLDivElement>) {
    // Check values
    const isLoginError = !isEmailValid(this.state.login);
    const isPasswordError = this.state.password.length < PASSWORD_SIZE;
    const isConfirmationError = this.state.confirmation !== this.state.password;

    this.setState({ isConfirmationError, isLoginError, isPasswordError });

    if (isLoginError || isPasswordError || isConfirmationError) {
      return;
    }

    this.props.onSignup(this.state.login, this.state.password);
  }

  /**
   * Fired when user change login input field
   * @param state 
   * @param event 
   */
  public onChangeLogin(state: IRegisterState, event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ login: event.currentTarget.value.toLowerCase(), isLoginError: this.state.isLoginError && !isEmailValid(event.currentTarget.value) });
  }

  /**
   * Fired when user change password input field
   * @param state 
   * @param event 
   */
  public onChangePassword(state: IRegisterState, event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ password: event.currentTarget.value, isPasswordError: this.state.isPasswordError && event.currentTarget.value.length < PASSWORD_SIZE });
  }

  /**
   * Fired when user change confirmation input field
   * @param state 
   * @param event 
   */
  public onChangeConfirmation(state: IRegisterState, event: React.ChangeEvent<HTMLInputElement>) {
    this.setState({ confirmation: event.currentTarget.value, isConfirmationError: this.state.isConfirmationError && event.currentTarget.value !== this.state.password });
  }

  /**
   * Fired when user click on menu hamburger button
   * @param event 
   */
  public onMenuClick(event: React.MouseEvent<HTMLDivElement>) {
    this.props.onGoHome();
  }

  public render() {

    const i18n = this.props.i18n;

    return (
      <div className="standardPage">
        <TitleBar
          leftIcon={ITitleBar.ICO_CHEVRON_LEFT}
          onLeftButtonClick={this.onMenuClick.bind(this, this.state)}
          title={i18n.Register.title}
        />
        <div className="contentCentered">
          <div>
            <img className="avatar" src={IMAGE_PATH + 'color3_100_user-circle@3x.png'} />
            <InputText icon={IInputText.ICO_USER_CIRCLE} maxLength={100} type="email" required={true} name={i18n.Common.email} id="login" isError={this.state.isLoginError} error={i18n.Common.errors.email} value={this.state.login} onChange={this.onChangeLogin.bind(this, this.state)} />
            <InputText icon={IInputText.ICO_KEY} type="password" required={true} name={i18n.Common.password} id="pass" isError={this.state.isPasswordError} value={this.state.password} error={i18n.Common.errors.password} onChange={this.onChangePassword.bind(this, this.state)} />
            <InputText icon={IInputText.ICO_KEY} type="password" required={true} name={i18n.Register.confirmation} id="confirm" isError={this.state.isConfirmationError} value={this.state.confirmation} error={i18n.Register.errors.confirmation} onChange={this.onChangeConfirmation.bind(this, this.state)} />
            <ErrorMessage message={i18n.Common.errors[this.props.errorMessage]} />
          </div>
        </div>
        <div id="footerButton">
          <Button label={i18n.Register.register} type={Btn.BTN_TYPE_LARGE} onClick={this.onSignupClick.bind(this, this.state)} />
        </div>
      </div>

    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/pages/Register.tsx